module.exports = __webpack_public_path__ + "img/fylke-16.7890cf04.svg";